import BaseService from '_services/rest/base';
import axios from 'axios';
import SessionService from '_services/common/sessionService';

/* eslint-disable new-parens */
export default new class UserService extends BaseService {
  // RULES for validation
  static get ADDRESS_RULES() {
    return {
      address: 'required',
      zipcode: 'required|numeric',
      city: 'required',
    };
  }

  static get PASSWORD_RULES() {
    return {
      password: 'required',
      password_confirmation: 'required|same:password',
    };
  }

  static get PROFILE_RULES() {
    return {
      name: 'required',
      phone: 'required|numeric',
      store_activated: 'required|boolean',
    };
  }

  static get USER_RULES() {
    return {
      name: 'required',
      username: 'required',
      email: 'required|email',
    };
  }

  // ATTRIBUTES NAME for validation
  static get PASSWORD_NAMES() {
    return {
      password_new: 'new password',
      password_confirmation: 'password confirmation',
    };
  }

  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/user`;
  }

  getAll(query) {
    return axios
      .get(this.getUrl(), {
        params: query,
      })
      .then(result => result.data.data)
      .catch(error => {
        throw this.error(error);
      });
  }

  setUserLocalStorage(expires) {
    return axios
      .get(this.getUrl())
      .then(result => {
        SessionService.setLocalData('_user', result.data);
        SessionService.setCookie('_id', result.data.id, expires);

        return result.data;
      })
      .catch(error => {
        throw this.error(error);
      });
  }

  save(user) {
    return this.request(`${this.getUrl()}/${user.id}`, user, 'PUT')
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }
}();
